export const WHITE_LABEL_CONSTANTS = {
  DEFAULT_PRIMARY_COLOR   : '#F5F2ED',
  DEFAULT_SECONDARY_COLOR : '#203040',
  DEFAULT_TEXT_COLOR      : '#111128',
  DEFAULT_SUCCESS_COLOR   : '#4fd384',
  DEFAULT_ERROR_COLOR     : '#dd564d',
  DEFAULT_DISABLED_COLOR  : '#828282',
  DEFAULT_ACCENT_COLOR    : '#B678F4',
  DEFAULT_FONT_FAMILY     : 'Whitney'
 }
